class PopinMedoc
{
  constructor()
  {

    this.container = document.body.querySelector('.Popin_medoc')
    if( !this.container ) return
    this.items = document.body.querySelectorAll('[data-medoc]')

    this.openPopin = this.openPopin.bind(this)
    this.closePopin = this.closePopin.bind(this)

    this.init()
  }

  init()
  {
    for (let i = 0; i < this.items.length; i++) {
      let element = this.items[i];
      element.addEventListener('click', this.openPopin )
    }

    this.container.querySelector('.Popin_close').addEventListener('click', this.closePopin )
    this.container.querySelector('.Popin_cache').addEventListener('click', this.closePopin )
  }

  closePopin()
  {
    document.body.querySelector('#site-container').style.overflowY = "auto"

    this.container.classList.remove('is-open')
  }

  openPopin(e)
  {
    e.preventDefault();

    let el = e.currentTarget;
    let data = el.getAttribute('data-medoc')

    this.medoc = JSON.parse(data)
    if(!this.medoc) return

    document.body.querySelector('#site-container').style.overflowY = "hidden"

    this.container.querySelector('.Medoc_dci').innerHTML = this.medoc.dci.replace('®', '®'.sup())
    this.container.querySelector('.Medoc_aire').innerHTML = this.medoc.aireTherapeutique
    
    if(this.medoc.dimensions === '-')
      this.container.querySelector('.Medoc_dimensions').style.display = "none"
    else
      this.container.querySelector('.Medoc_dimensions').style.display = "block"

    this.container.querySelector('.Medoc_dimensions span').innerHTML = this.medoc.dimensions
    this.container.querySelector('.Medoc_cip').innerHTML = this.medoc.cip
    this.container.querySelector('.Medoc_tarif b').innerHTML = this.medoc.tarif != '-' ? this.medoc.tarif + '€' : '-'
    this.container.querySelector('.Medoc_tarifPH b').innerHTML = this.medoc.tarifPH != '-' ? this.medoc.tarifPH + '€' : '-'
    // this.container.querySelector('.Medoc_tarifPublic b').innerHTML = this.medoc.tarifPublic != '-' ? this.medoc.tarifPublic + '€' : '-'
    this.container.querySelector('.Medoc_tr b').innerHTML = this.medoc.tr

    if(this.medoc.eenGenerique == 'Identique au princeps' || this.medoc.eenPrinceps == 'Identique au princeps' || this.medoc.eenPrinceps  == this.medoc.eenGenerique)
    {
      this.container.querySelector('.eenGlobal').style.display = 'table-cell'
      this.container.querySelector('.eenZentiva').style.display = 'none'
      this.container.querySelector('.eenPrinceps').style.display = 'none'
      this.container.querySelector('.eenGlobal .Medoc_eenPrinceps').innerHTML = this.medoc.eenPrinceps
      this.container.querySelector('.eenGlobal .Medoc_eenGenerique').innerHTML = 'Identique aux princeps'
    }else
    {
      this.container.querySelector('.eenGlobal').style.display = 'none'
      this.container.querySelector('.eenZentiva').style.display = 'table-cell'
      this.container.querySelector('.eenPrinceps').style.display = 'table-cell'

      this.container.querySelector('.eenPrinceps .Medoc_eenPrinceps').innerHTML = this.medoc.eenPrinceps
      this.container.querySelector('.eenZentiva .Medoc_eenGenerique').innerHTML = this.medoc.eenGenerique
    }

    let princeps2 = this.medoc.princeps2 != "-" ? '</br>' + this.medoc.princeps2 : ""
    this.container.querySelector('.Medoc_princeps').innerHTML = this.medoc.princeps + princeps2

    // if(this.medoc.identiquePrinceps === "OUI")
    // {
    //   this.container.querySelector('.Medoc_identique').style.display = "block"
    // }
    // else
      // this.container.querySelector('.Medoc_identique').style.display = "none"

    if(this.medoc.tfr === "OUI")
    {
      this.container.querySelector('.Medoc_tfr').style.display = "block"
    }
    else
      this.container.querySelector('.Medoc_tfr').style.display = "none"

    if(this.medoc.boite)
    {
      this.container.querySelector('.Medoc_preview').src = this.medoc.boite
      this.container.querySelector('.Medoc_preview').style.display = "block"
    }
    else
      this.container.querySelector('.Medoc_preview').style.display = "none"

    if(this.medoc.pilule)
    {
      this.container.querySelector('.Medoc_previewMedoc').src = this.medoc.pilule
      this.container.querySelector('.Medoc_previewMedoc').style.display = "inline-block"
    }
    else
      this.container.querySelector('.Medoc_previewMedoc').style.display = "none"

    if(this.medoc.code)
    {
      this.container.querySelector('.Medoc_code').src = this.medoc.code
      this.container.querySelector('.Medoc_code').style.display = "inline-block"
    }
    else
      this.container.querySelector('.Medoc_code').style.display = "none"


    this.container.classList.add('is-open')
  }
}

export default PopinMedoc;


// WEBPACK FOOTER //
// ./src/js/partials/PopinMedoc.js